const bookNowButton = document.querySelector('.js-book-now');

if (bookNowButton) {
    let url = new URL(bookNowButton.dataset.href);

    bookNowButton.addEventListener('click', (event) => {
        window.location.href = url.href;
    });
}